/* Change this file to get your personal Portfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
  title: "Siddharth Notani ",
  logo_name: "Siddharth Notani",
  nickname: "Sidd",
  subTitle:
    "Hard working and passionate Software and AI Engineer \u{1F680} with an interest in Applied AI & Blockchain. \n\n I thrive to make the world a better place with the use of innovative tech.",
  resumeLink:
    "https://drive.google.com/file/d/1ifyLLXsIj7xtPEMCuOyfV9Kyzjak98Le/view?usp=sharing",
  portfolio_repository: "https://github.com/snotani/snotani.github.io",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/snotani",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/siddharth-notani",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:sidd9torres@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/siddsiddi",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/siddharth.notani/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/siddi.notani/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
  {
    name: "Mediuim",
    link: "https://medium.com/@sidd9torres",
    fontAwesomeIcon: "fa-medium", // Reference https://fontawesome.com/icons/medium?style=brands
    backgroundColor: "#12100E", // Reference https://simpleicons.org/?q=medium
  },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "\u26A1 Developing hybrid mobile applications using React Native and Flutter and native applications for iOS using Swift",
        "\u26A1 Building responsive websites and web apps using React",
        "\u26A1 Creating application backend in Node, Express & Flask",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Swift",
          fontAwesomeClassname: "simple-icons:swift",
          style: {
            color: "#FA7343",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#F96F29",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
      ],
    },
    {
      title: "Cloud Computing",
      fileName: "CloudInfraImg",
      skills: [
        "\u26A1 Hosting and maintaining apps on EC2 instances with serverless on AWS and Heroku",
        "\u26A1 Deploying machine learning models on Azure Cloud",
        "\u26A1 Setting up private blockchains and servers on Google Cloud",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Google Cloud",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#FFBB00",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#430098",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Linux",
          fontAwesomeClassname: "simple-icons:linux",
          style: {
            color: "#FCC624",
          },
        },
      ],
    },
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "\u26A1 Training machine learning models for the prediction of things like COVID-19 or Stocks",
        "\u26A1 Currently learning about Computer Vision using OpenCV",
        "\u26A1 Using Tensorflow to train neural networks for detection of spam and offensive languages ",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Jupyter Notebook",
          fontAwesomeClassname: "simple-icons:jupyter",
          style: {
            backgroundColor: "transparent",
            color: "#F37626",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "R",
          fontAwesomeClassname: "simple-icons:r",
          style: {
            backgroundColor: "transparent",
            color: "#276DC3",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "\u26A1 Designing highly attractive user interfaces for mobile and web applications",
        "\u26A1 Creating prototypes and user flows to optimize user experience",
        "\u26A1 Conducting user research and testing to adapt to their needs",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Framer",
          fontAwesomeClassname: "simple-icons:framer",
          style: {
            color: "#0055FF",
          },
        },
        {
          skillName: "Invision",
          fontAwesomeClassname: "simple-icons:invision",
          style: {
            color: "#FF3366",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/",
    },
    {
      siteName: "FreeCodeCamp",
      iconifyClassname: "simple-icons:freecodecamp",
      style: {
        color: "#0A0A23",
      },
      profileLink: "https://www.freecodecamp.org/",
    },
    {
      siteName: "Exercism",
      iconifyClassname: "simple-icons:exercism",
      style: {
        color: "#009CAB",
      },
      profileLink: "https://exercism.io/",
    },
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F89F1B",
      },
      profileLink: "https://www.leetcode.com/",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Lancaster University",
      subtitle: "MSc Data Science",
      logo_path: "lu_logo.png",
      alt_name: "Lancaster Uni",
      duration: "2020 - Present",
      descriptions: [
        "\u26A1 Key modules: Data mining, Distributed AI, Big Data Systems, Generalised Linear Models, Likelihood Inference, Data Science in R",
        "\u26A1 Clubs and societies: Investment and Finance society, Chess Club, Football club, Indian & Spanish society",
        "\u26A1 Earned two scholarships for academic excellence and alumni loyalty to do this masters degree.",
      ],
      website_link: "http://lancaster.ac.uk/study/chat",
    },
    {
      title: "Lancaster University",
      subtitle: "BSc Software Engineering",
      logo_path: "lu_logo.png",
      alt_name: "Lancaster Uni",
      duration: "2017 - 2020",
      descriptions: [
        "\u26A1 Key modules: AI, Distributed & Embedded Systems, OS, Adv.Programming, Databases, HCI, Networking, Software Design",
        "\u26A1 Clubs and societies: Enactus UK, Comp Sci society, Chess Club, Football Club, Ethical Hacking society, Indian & Spanish society",
        "\u26A1 Worked as a Front-End Web Developer at the University IT Department and Software Engineer in multiple local start-ups",
      ],
      website_link: "http://lancaster.ac.uk/study/chat",
    },
    {
      title: "The British School of Gran Canaria",
      subtitle: "A Levels, High School",
      logo_path: "bsgc_logo.svg",
      alt_name: "BSGC",
      duration: "2005 - 2017",
      descriptions: [
        "\u26A1 A Level Subjects and Grades: A* - Spanish, A - Mathematics, B - Physics, B - Business Studies",
        "\u26A1 Clubs and societies: Chess Club, Debate club, Drama club, Football team, Maths club",
        "\u26A1 During my time here, I volunteered in a Geriatric hospital and was as a Student Mentor & Maths Tutor for an IGCSE student",
      ],
      website_link: "http://lancaster.ac.uk/study/chat",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link: "",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link: "",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      certificate_link: "",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link: "",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link: "",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link: "",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link: "",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link: "",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link: "",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link: "",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteering",
  description:
    "I have worked with multiple start-ups and multinational companies as a Sofware Engineer, Mobile Developer, Technology Analyst or AI Researcher. I really enjoy exploring roles in different sectors such as Finance and Science to see how tech can be used to improve the systems.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Co-Founder and CTO",
          company: "Magknit",
          company_url: "https://magknit.co.uk",
          logo_path: "magknit_logo.jpeg",
          duration: "June 2019 - PRESENT",
          location: "Lancaster, UK",
          description:
            "The implementor and co-founder of Magknit, Siddharth is in the driving seat for developing, implementing, managing and evaluating Magknit\u2019s app and technological resources. - iOS and Android developer for native mobile apps in Swift and Kotlin respectively. - Back-end developer with REST API integrations in Node Js and Mysql.",
          color: "#0879bf",
        },
        {
          title: "Software Developer",
          company: "AlgoWealth Technologies",
          company_url: "https://www.algowealth.net",
          logo_path: "aw_logo.jpeg",
          duration: "May 2019 - PRESENT",
          location: "San Francisco, California, USA",
          description:
            "AlgoWealth is an automated trading software that buys and sells currencies in the forex market with the use of several tailored algorithmic strategies. I successfully Developed a Mobile App using React Native for cross-platform development, Developed strategic algorithms in C# / .NET with the use of cAlgo API in cTraderProgrammed CandlePattern identifications for algortihmic strategiesUsed OOP principles with C#/.NET",
          color: "#527189",
        },
        {
          title: "Lead Software Engineer",
          company: "Agnes Control",
          company_url: "https://www.agnescontrol.co.uk/",
          logo_path: "ag_logo.jpeg",
          duration: "February 2020 - PRESENT",
          location: "Lancaster, UK",
          description:
            "I work with IoT Smart devices such as smart locks to create a prototype of locking/unlocking your door with just the tap from your phone. I use Flutter, Firebase and Django to create a mobile app and back-end to then deploy the IoT solution.",
          color: "#9b1578",
        },
        {
          title: "Undergraduate Teaching Assistant",
          company: "Lancaster University",
          company_url: "http://lancaster.ac.uk/scc",
          logo_path: "scc_logo.jpeg",
          duration: "February 2019 - PRESENT",
          location: "Lancaster, UK",
          description:
            "As an Undergraduate Teaching Assistant for first year students studying Software Engineering / Computer Science at Lancaster University, I am responsible to: - Weekly aid the learning of around 20-30 students each lab session in the Software Development module (in C and Java) and Information Systems (SQL - Databases)- Successfully mentor a group of 6 students in programming modules (Fundamentals of Computer Science) as a PASS Leader",
          color: "#B11121",
        },
        {
          title: "Mathematics & Spanish Tutor",
          company: "Tutorful",
          company_url: "http://tutorful.co.uk",
          logo_path: "tutorful_logo.png",
          duration: "October 2017 - PRESENT",
          location: "Lancaster, UK",
          description:
            "Tutored 8 IGCSE Mathematics students helping them successfully pass and achieve their potential in the examinationsFrom the previously gained experience as a Mathematics mentor at School, I decided I wanted to keep on mentoring IGCSE students so I could help them and could further develop my thinking and communications skills. I have tutored 8 IGCSE Mathematics students in this time which were very satisfied with my teaching skills and their improvement in the subject.",
          color: "#2C3553",
        },
        {
          title: "Senior Ambassador",
          company: "Unibuddy",
          company_url: "http://unibuddy.co.uk",
          logo_path: "unibuddy_logo.png",
          duration: "October 2017 - PRESENT",
          location: "Lancaster, UK",
          description:
            "I am currently a Unibuddy Ambassador representing Lancaster University. Prospective students from all different backgrounds contact me to get to know more about the student life at Lancaster, more about a particular course, accommodation, clubs and societies or anything related to the University. - This opportunity has enhanced my effective communication skills while interacting with prospective students - Chatting informally with prospective students has also led me to friendliness towards them. - I have also improved on conveying the right message to the right student when necessary.",
          color: "#02D5CF",
        },
        {
          title: "Front-end Web Developer",
          company: "ITPI Lancaster University",
          company_url: "http://itpi.lancaster.ac.uk/",
          logo_path: "iss_logo.png",
          duration: "January 2020 - July 2020",
          location: "Lancaster, UK",
          description:
            "\u2022 Engineered React based apps distributed an estimated 15,000 users including session booking and time management tools.\u2022 Collaborated within a wider team to leverage the Microsoft Azure Digital Twins service with a long-term goal of controlling lighting and heating across campus to save energy.",
          color: "#504F50",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Technology Analyst Intern",
          company: "Deutsche Bank",
          company_url: "https://db.com/",
          logo_path: "db_logo.jpeg",
          duration: "June 2020 - August 2020",
          location: "London, UK - Virtual",
          description:
            "As a Technology Analyst Intern at DB I was able to get a full insight into the evolution of tech in the banking industry in a multi-national company. I had the chance to network with a lot of important people in the FinTech Industry. I worked on building a Machine Learning model that was able to predict the spread of COVID-19 over the US states and the different countries around the world with the use of different parameters. I got the chance to look into the future of banking and network with highly skilled and important people in the industry.",
          color: "#000FAD",
        },
        {
          title: "Mobile Development Intern",
          company: "Coderus Ltd",
          company_url: "https://coderus.com",
          logo_path: "coderus_logo.png",
          duration: "May 2019 - September 2019",
          location: "Ipswich, UK",
          description:
            "Being able to join Coderus as a Mobile Development intern has been a great opportunity for me to further develop my skills and broaden my horizons. It has allowed me to network with a wide range of people from all backgrounds and learn about all the different opportunities to learn from in industry. Having been part of the quality assurance team at first and then moving into an agile development team has given me a better insight of the software-development life cycle applied in the industry. Having regular sprint planning and reviews as part of the development team has enhanced my communication skills as well as allowing me to adapt to a fast-paced work environment and facing new challenges. I had the chance to work in the development of the Bowers & Wilkins Apps, getting hands-on experience with the Software Development Life-Cycle methodologies and working within an agile/scrum team. I was introduced to new languages such as Kotlin and new tools such as Docker for running development environment, Jenkins for CI/CD, JIRA for agile development and TestRail for testing.",
          color: "#000000",
        },
        {
          title: "Software Developer Intern",
          company: "SCC, Lancaster University",
          company_url: "http://lancaster.ac.uk/scc",
          logo_path: "scc_logo.jpeg",
          duration: "June 2018 - September 2018",
          location: "Lancaster, UK",
          description:
            "At this 12-week Summer Internship, I worked on developing an App for the Study Abroad Scheme at Lancaster University. - This App/Algorithm allocates students willing to go to Study Abroad to one of their chosen Host Institutions depending on a series of rules, facilitating work for the Global Experiences Team and saving time from how it was done in previous years. - I used JavaScript and jQuery to carry out the development of this App. - This internship of developing an App has helped me put my theoretical knowledge into practice and hence challenging my programming skills and giving me a competitive edge in the real world.",
          color: "#AF1517",
        },
      ],
    },
    {
      title: "Volunteering",
      experiences: [
        {
          title: "AI Research Volunteer",
          company: "Lancaster University",
          company_url: "https://www.lancaster.ac.uk/scc",
          logo_path: "scc_logo.jpeg",
          duration: "July 2020 - PRESENT",
          location: "Lancaster, UK",
          description:
            "I collaborated on creating Influence Maximisation Algorithms using deep neural networks which can then be used to find out how the users across social media can be reached out the most.",
          color: "#B31417",
        },
        {
          title: "Programming Teacher",
          company: "Gledus",
          company_url: "https://www.gledus.com/",
          logo_path: "gledus_logo.jpeg",
          duration: "October 2019 - November 2019",
          location: "Cumbria, UK",
          description:
            "I spent a week on a bootcamp as a programming teacher to show younger students the fundamental concepts of Java and to build a Table Tennis game with a GUI in Java. We also made some fun games with Scratch.",
          color: "#BDD04C",
        },
        {
          title: "Future Leaders Experience & Capital Connections",
          company: "Lancaster University Careers",
          company_url: "https://www.lancaster.ac.uk",
          logo_path: "lucareers_logo.png",
          duration: "April 2020 - June 2020",
          location: "Virtual",
          description:
            "Part of a program where I enhanced my leadership skills and networked with people from all industried. Some employers include: Google, Bloomberg, Deloitte, AstraZenca etc.",
          color: "#fc1f20",
        },
        {
          title: "Student Mentor, Maths Tutor & Helper",
          company: "The British School of Gran Canaria",
          company_url: "https://www.bs-gc.com",
          logo_path: "bsgc_logo.svg",
          duration: "September 2015 - June 2017",
          location: "Gran Canaria, Spain",
          description:
            "Mentored a Year 10 IGCSE Student and tutored Mathematics. I socially commited and volunteered in a Geriatric Hospital weekly to help out and take care of elderly and disabled people through a time period of 2 years.",
          color: "#2A2D69",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects include a range of tech stacks and tools. Most projects are personal projects that I work on to build and learn new languages or concepts. ",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "sidd_logo4.png",
    description:
      "Feel free to get in touch with me on social media, I will try to get back to you as soon as possible. I can help with Website & App development, Cloud development, IT Consultations, Blockchain and Trading",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to write blogs about the different technologies I have experienced and recommend, tips to study/work and stay productive and some motivational blogs out of inspiration.",
    link: "https://medium.com/@sidd9torres",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Lancaster, UK \u{1F1EC}\u{1F1E7} | Gran Canaria, Spain \u{1F1EA}\u{1F1F8}",
    avatar_image_path: "address_image.svg",
    location_map_link:
      "https://goo.gl/maps/MpMqtRhttps://www.google.com/maps/place/Lancaster/@54.0452479,-2.7944289,13.48z/data=!4m5!3m4!1s0x487b6279a8e97dbd:0xe030ef3d8b443c41!8m2!3d54.04874!4d-2.807454ZytFchMkZ76",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+44 7597241542 / +34 679540896",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
